import React from 'react';
import ReactDOM from 'react-dom';
import Icon from './Icon';
import BikeDetailPage from '../pages/BikeDetailPage';

/**
 * Modal that shows the Bike Passport page (BikeDetailPage) directly - no iframe.
 * Renders via portal to document.body so it appears above sidebar (z-index 10000).
 */
export default function BikePassportModal({ bikeId, bikeLabel, onClose, darkMode = true, user, onLogout, onToggleDarkMode, onUserUpdate }) {
  if (!bikeId || !user) return null;

  const modalContent = (
    <div
      className="modal-overlay bike-passport-modal-overlay"
      onClick={onClose}
      style={{
        zIndex: 100001,
        position: 'fixed',
        inset: 0,
        background: darkMode ? 'rgba(0,0,0,0.95)' : 'rgba(0,0,0,0.35)',
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'stretch',
      }}
    >
      <div
        className="modal modal-large bike-passport-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderRadius: 0,
          margin: 0,
          maxWidth: 'none',
          maxHeight: '100vh',
          width: '100%',
          height: '100vh',
        }}
      >
        <div style={{ flex: 1, minHeight: 0, overflow: 'auto', position: 'relative' }}>
          <button
            className="close-btn"
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '14px',
              right: '16px',
              zIndex: 20,
              fontSize: '20px',
              padding: '4px',
              background: darkMode ? 'rgba(0,0,0,0.35)' : 'rgba(255,255,255,0.8)',
              border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
              color: darkMode ? '#ffffff' : '#1a1a1a'
            }}
            aria-label={bikeLabel ? `Close bike passport for ${bikeLabel}` : 'Close bike passport'}
          >
            <Icon name="close" color="primary" darkMode={darkMode} size={20} />
          </button>
          <BikeDetailPage
            user={user}
            onLogout={onLogout}
            darkMode={darkMode}
            onToggleDarkMode={onToggleDarkMode || (() => {})}
            onUserUpdate={onUserUpdate}
            overrideBikeId={bikeId}
            forceEmbedded={true}
          />
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
